import * as Sentry from '@sentry/vue';
import { AxiosRequestConfig, AxiosRequestInterceptorParams } from 'axios';
import { logError } from '@utils/error-tracking';

/**
 * If a WAF token isn’t present, runs logic to get the token.
 */
async function WafTokenRequest(config: AxiosRequestConfig): Promise<AxiosRequestConfig<unknown>> {
	if (window.AwsWafIntegration) {
		Sentry.addBreadcrumb({
			category: 'waf',
			message: 'WAF request initiated',
			level: 'info',
			data: { hasWafTok: window.AwsWafIntegration.hasToken() }
		});
		await window.AwsWafIntegration.getToken().catch(logError);
	} else {
		Sentry.addBreadcrumb({
			category: 'waf',
			message: 'WAF library not loaded on initial request',
			level: 'info'
		});
	}

	return config;
}

export const wafTokenRequestInterceptor: AxiosRequestInterceptorParams = [(config) => WafTokenRequest(config)];
